import React from 'react'
import SkeletonBlock from '@component/skeleton/SkeletonBlock'
import Text from '@component/Text/Text'
import {useTranslation} from '@lib/intl/useTranslations'

interface IProps {
    className?: string
}

const SkeletonLeagueList: React.FC<IProps> = ({className}) => {
    const t = useTranslation()
    return Array.from({length: 30}, (_, i) => i)?.map(item => (
        <div
            key={item}
            className={`py-[20px] px-[30px] rounded-[5px] cursor-pointer border border-gray07 dark:border-dark_gray07 hover:bg-indigo_tint01 dark:hover:bg-dark_indigo_tint01`}>
            <div className={'flex gap-x-[5px] justify-between items-center w-full'}>
                <SkeletonBlock className={'w-[30px] h-[30px]'} sizeClassName={'h-[30px] !rounded-[5px]'} />
                <div className={'ml-[15px] flex-1 flex-grow'}>
                    <SkeletonBlock className={'w-[150px] h-[24px]'} sizeClassName={'h-[16px]'} />
                    <SkeletonBlock className={'w-[95px] h-[18px]'} sizeClassName={'h-[12px]'} />
                </div>
                <div className={'flex flex-1 sm:hidden'}>
                    <div className={'px-2 text-center flex-1'}>
                        <Text className={'text-body3 text-gray03 dark:text-dark_gray03'}>
                            {t('leaderboard.leagueList.previousLeagues.item.myRanking.header.title')}
                        </Text>
                        <SkeletonBlock className={'w-[60%]  h-[24px] mx-auto'} sizeClassName={'h-[16px]'} />
                    </div>
                    <div className={'px-2 text-center flex-1'}>
                        <Text className={'text-body3 text-gray03 dark:text-dark_gray03'}>
                            {t('leaderboard.leagueList.previousLeagues.item.participants.header.title')}
                        </Text>
                        <SkeletonBlock className={'w-[60%]  h-[24px] mx-auto'} sizeClassName={'h-[16px]'} />
                    </div>
                    <div className={'px-2 text-center flex-1'}>
                        <Text className={'text-body3 text-gray03 dark:text-dark_gray03'}>
                            {t('leaderboard.leagueList.previousLeagues.item.prizePool.header.title')}
                        </Text>
                        <SkeletonBlock className={'w-[60%] h-[24px] mx-auto'} sizeClassName={'h-[16px]'} />
                    </div>
                    <div className={'flex items-center md:hidden'}>
                        <div className={'p-[3px]'}>
                            <div className={'w-[18px]'} />
                        </div>
                    </div>
                </div>
            </div>
        </div>
    ))
}

export default SkeletonLeagueList
